import type {
  CreateInterestPayload,
  Interest,
  UpdateInterestPayload,
} from '@/domain/interests/entities/interest.entity'
import type {
  InterestRepository,
  ListInterestsParams,
} from '@/domain/interests/repositories/interest_repository'
import { mapInterestDtoToEntity } from '../mappers/interest.mapper'
import { InterestsRtkDatasource } from '../datasources/interests_rtk_datasource'

export class InterestRepositoryImpl implements InterestRepository {
  constructor(private readonly remote: InterestsRtkDatasource = new InterestsRtkDatasource()) {}

  async list(params: ListInterestsParams = {}): Promise<Interest[]> {
    const items = await this.remote.list(params.page ?? 0, params.limit ?? 50)
    return items.map(item => mapInterestDtoToEntity(item))
  }

  async getById(id: string): Promise<Interest> {
    const item = await this.remote.getById(id)
    return mapInterestDtoToEntity(item)
  }

  async create(payload: CreateInterestPayload): Promise<Interest> {
    const item = await this.remote.create(payload)
    return mapInterestDtoToEntity(item)
  }

  async update(payload: UpdateInterestPayload): Promise<Interest> {
    const item = await this.remote.update(payload)
    return mapInterestDtoToEntity(item)
  }

  async delete(id: string): Promise<void> {
    await this.remote.delete(id)
  }
}

export const interestRepository = new InterestRepositoryImpl()
